const SidebarItems = [
  {
    name: "Search",
    route: "/",
    childrens: [],
  },
  {
    name: "Upload",
    route: "/upload",
    childrens: [],
  },
  {
    name: "Admin",
    route: "/admin",
    childrens: [],
  },
  {
    name: "Top 10",
    route: "/top10",
    childrens: [],
  },
];

export default SidebarItems;
